/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from "react";
import { getAllAddonsListApi } from "../service/ZohoPlanService";
// import { getAllAddonsListApi } from "services/eSignService";

const useZohoPlanAddonsList = () => {
  const [addons, setAddons] = useState({});
  const getAddonsList = async () => {
    try {
      const data = await getAllAddonsListApi();
      if (Array.isArray(data?.data)) {
        const finalData = {};
        data?.data?.forEach((element) => {
          if (element?.applicable_to_all_plans) {
            if (!finalData["forAllPlans"]) {
              finalData["forAllPlans"] = [];
            }
            finalData["forAllPlans"].push(element);
          } else {
            if (!finalData[element?.plans?.[0]?.plan_code]) {
              finalData[element?.plans?.[0]?.plan_code] = [];
            }
            finalData[element?.plans?.[0]?.plan_code].push(element);
          }
        });
        setAddons(finalData);
      }
    } catch (error) {
      console.log(error, "newDtaay");
    }
  };
  useEffect(() => {
    getAddonsList();
  }, []);
  return { addonsList: addons };
};

export default useZohoPlanAddonsList;
